var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn btn-default btn-sm",attrs:{"title":_vm.title}},[_c('i',{class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }